import { render, staticRenderFns } from "./BandGallery.vue?vue&type=template&id=5f0452a9"
import script from "./BandGallery.vue?vue&type=script&lang=js"
export * from "./BandGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports